<template>
  <div id="messageImageNtext">
    <div class="messtitle"><div>圖文訊息  </div> <span></span></div>

    <div class="messtitle" :style="{marginTop: '11px'}"><div>標題   </div> <span>(請輸入20字內)</span></div>
    <input type="text" v-model="content.title">
    <div class="messtitle" :style="{marginTop: '26px'}"><div>圖片  </div> <span></span></div>
    <File :folder="'message'" :bg="'var(--color-pri)'" :style="{width: '660px', height: '450px', marginLeft: 0, marginTop: '13px'}"
    :defaultValue="content.image" @input="content.image=$event"/>
    <div class="messtitle" :style="{marginTop: '11px'}"><div>連結   </div> <span></span></div>
    <input type="text" v-model="content.link">
    <div class="messtitle" :style="{marginTop: '49px'}"><div>文字內文 </div> <span>(請輸入500字內)</span></div>
    <textarea v-model="content.content" ref="text"></textarea>
  </div>
</template>

<script>
import File from '../../../components/input/file3.vue'
export default {
  props: ['defaultValue'],
  components: {
    File
  },
  data () {
    return {
      content: {
        title: null,
        image: null,
        content: null,
        link: null
      }
    }
  },
  watch: {
    content () {
      this.$emit('input', this.content)
    },
    defaultValue: {
      handler () {
        if (!this.defaultValue) {
          this.content = {
            title: null,
            image: null,
            content: null,
            link: null
          }
        } else if (typeof this.defaultValue === 'string' && (/.png/.test(this.defaultValue) || /.jpg/.test(this.defaultValue))) {
          this.content = {
            title: null,
            image: this.defaultValue,
            content: null,
            link: null
          }
        } else if (typeof this.defaultValue === 'string' && !(/.png/.test(this.defaultValue) || /.jpg/.test(this.defaultValue))) {
          this.content = {
            title: null,
            image: null,
            content: this.defaultValue,
            link: null
          }
        } else {
          const { title, image, content, link } = this.defaultValue
          this.content.title = title
          this.content.image = image
          this.content.content = content
          this.content.link = link
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style lang="scss">
#messageImageNtext {
  rect {
    background-color: var(--color-pri);
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.messtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  height: 26px;
  gap: .5em;
  span {
    font-size: 12px;
    font-weight: 500;
    font-family: Roboto;
    line-height: 14px;
    color: #C4C4C4;
  }
}
input[type=text] {
  height: 40px;
  border: 1px solid #C4C4C4;
  border-radius: 5px;
  color: #878787;
  width: 100%;
  margin-top: 11px;
  padding: 25px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
  color: #787878;
}
textarea {
  height: 375px;
  border: 1px solid #C4C4C4;
  border-radius: 5px;
  color: #878787;
  width: 100%;
  margin-top: 11px;
  padding: 25px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
  color: #787878;
}
#messageImageNtext {
  width: 790px;
  height: fit-content;
  border: 1px solid #CACACA;
  border-radius: 10px;
  padding: 25px 33px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
